'use strict';

/**
 * library
 */
import 'slick-carousel';

/**
 * tab_language
 */
export const tab_language = (() => {
    const $nav = $('.js-nav-tab');
    const $item = $('.js-item-tab');
    let classes = [];

    $nav.find('.nav-tab__item').each(i => {
        if (i > 0) {
            classes += ' nav-tab--' + (i + 1);
        } else {
            classes += 'nav-tab--' + (i + 1);
        }
    });

    const init = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        $nav.on('init', (e, slick) => {
            if(location.hash === '#column') {
                setTimeout(() => {
                    $('.slick-slide[data-slick-index="2"]').trigger('click');
                }, 100);
            }
        });

        $nav.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
            $nav.removeClass(classes);
            $nav.addClass('nav-tab--' + (nextSlide + 1));
        });

        $nav.slick({
            speed: 300,
            infinite: false,
            draggable: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: false,
            centerPadding: '0',
            focusOnSelect: true,
            asNavFor: $item[0],
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: true,
                        draggable: true,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }
            ]
        });

        $item.slick({
            fade: true,
            speed: 200,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '0',
            asNavFor: $nav[0],
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        fade: false,
                        speed: 300,
                        variableWidth: true
                    }
                }
            ]
        });

        if (langParam === 'en') {
            $nav.find('.nav-tab__item--1').trigger('click');
            setLanguageSettings('en', 'Greetings｜Kabuki Nyantaro', 'Greetings from Kabuki Nyantarou.');
        } else if (langParam === 'ko') {
            $nav.find('.nav-tab__item--2').trigger('click');
            setLanguageSettings('ko', '인사말 | 카부키 냥타로', '카부키 냥타로의 인사말.');
        } else if (langParam === 'zh-cn') {
            $nav.find('.nav-tab__item--3').trigger('click');
            setLanguageSettings('zh-CN', '问候｜歌舞伎二太郎', '来自歌舞伎娘太郎的问候。');
        } else if (langParam === 'zh-tw') {
            $nav.find('.nav-tab__item--4').trigger('click');
            setLanguageSettings('zh-TW', '問候｜歌舞伎二太郎', '來自歌舞伎娘太郎的問候。');
        }
    };

    const setLanguageSettings = (htmlLang, title, description) => {
        document.documentElement.lang = htmlLang;
        document.title = title;

        const metaElements = {
            'meta[property="og:title"]': title,
            'meta[property="og:site_name"]': title,
            'meta[name="twitter:title"]': title,
            'meta[name="description"]': description,
            'meta[property="og:description"]': description,
            'meta[name="twitter:description"]': description
        };

        for (const selector in metaElements) {
            const metaElement = document.querySelector(selector);
            if (metaElement) {
                metaElement.content = metaElements[selector];
            }
        }
    };

    return {
        init: init
    };
})();
